import React, { SyntheticEvent } from 'react';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import CheckUserAccess from 'src/finsight/ui/common/components/CheckUserAccess';
import { IconComponentType } from '@dealroadshow/uikit/core/components/Icon';
import IconExpandAll from '@dealroadshow/uikit/core/components/Icon/IconExpandAll';
import IconCollapseAll from '@dealroadshow/uikit/core/components/Icon/IconCollapseAll';
import { useDealAccess } from '@/finsight/ui/components/deals/useDealAccess';

import styles from '@/finsight/ui/components/deals/DealListTable/components/DealButtons/dealButtons.scss';

const iconsMap = {
  collapseAll: {
    title: 'Collapse all',
    className: styles.collapseAllBtn,
    icon: IconCollapseAll,
  },
  expandAll: {
    title: 'Expand all',
    className: styles.expandAllBtn,
    icon: IconExpandAll,
  },
};

interface IDealButtonProps {
  title?: string | React.ReactNode,
  className?: string,
  icon?: IconComponentType,
  onClick: (e: SyntheticEvent) => void,
  dataTest?: string,
}

const ExpandCollapseButton = ({
  title,
  className,
  icon: Icon,
  onClick,
  dataTest,
}: IDealButtonProps) => {
  const { userAccessChecks } = useDealAccess();

  return (
    <div className={ styles.expandCollapseWrapper }>
      <CheckUserAccess
        checks={ userAccessChecks }
        fallback={ (
          <Icon className={ className } />
        ) }
      >
        <Tooltip content={ title }>
          <Icon
            className={ className }
            onClick={ onClick }
            data-test={ dataTest }
          />
        </Tooltip>
      </CheckUserAccess>
    </div>
  );
};

export const ExpandAllButton = ({ onClick }: IDealButtonProps) => (
  <ExpandCollapseButton { ...iconsMap.expandAll } onClick={ onClick } dataTest="expandAllDeals" />
);

export const CollapseAllButton = ({ onClick }: IDealButtonProps) => (
  <ExpandCollapseButton { ...iconsMap.collapseAll } onClick={ onClick } dataTest="collapseAllDeals" />
);
